// `slide-starter-pack`: "> Show a graphic of a starter pack for vibe coding." — the Digital
// Innovation Team's starter pack contents, as the script names them (docs/PRESENTATION.md,
// "Wrapping up").
//
// Its heading ("The vibe coding starter pack") went with every other slide heading on 2026-08-11 —
// the presenter names the pack, the slide lists it (user story 2). `STARTER_PACK_TITLE` was deleted
// with it; the three items keep their cards, recoloured to the brand rather than stripped to type.

import type { ReactElement } from 'react';
import { SlideFrame } from './SlideFrame';
import { SLIDE_SCALE } from './scale';
import { STARTER_PACK_ITEMS, STARTER_PACK_SUBTITLE, STARTER_PACK_TITLE } from './content';

export function StarterPackSlide(): ReactElement {
  return (
    <SlideFrame>
      <h1 style={{ margin: 0, fontSize: SLIDE_SCALE.title, color: 'var(--deck-card-border)' }}>
        <u>{STARTER_PACK_TITLE}</u>
      </h1>
      <p style={{ margin: 0, fontSize: SLIDE_SCALE.body, color: 'var(--deck-ink)' }}>
        {STARTER_PACK_SUBTITLE}
      </p>
      <div
        className="demo-stagger"
        style={{
          margin: 0,
          padding: 0,
          display: 'grid',
          gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
          gap: 'var(--sp-5)',
        }}
      >
        {STARTER_PACK_ITEMS.map((item) => (
          <div
            key={item}
            style={{
              display: 'flex',
              alignItems: 'center',
              fontFamily: 'var(--font-body)',
              fontWeight: 500,
              fontSize: SLIDE_SCALE.caption,
              color: 'var(--deck-ink)',
              background: 'var(--deck-card)',
              border: '3px solid var(--deck-card-border)',
              borderRadius: 'var(--r-lg)',
              padding: '26px 36px',
            }}
          >
            {item}
          </div>
        ))}
      </div>
    </SlideFrame>
  );
}
